/**
 * React Hook for timezone and localization utilities
 * Provides easy access to IST time functions with automatic user localization
 */

import { useMemo } from 'react';
import {
  formatDate,
  formatDateTime,
  formatTime,
  formatDateShort,
  formatRelativeTime,
  formatCurrency,
  formatNumber,
  getCurrentIST,
  getUserLocale,
  getUserTimezone,
  isToday,
  isPast,
  isFuture,
  getISTTimezoneName,
  formatDateTimeLocal,
} from '../utils/timezone';

export function useTimezone() {
  const timezone = useMemo(() => ({
    // User info
    userLocale: getUserLocale(),
    userTimezone: getUserTimezone(),
    istTimezone: getISTTimezoneName(),

    // Current time
    getCurrentIST,

    // Formatting functions
    formatDate,
    formatDateTime,
    formatTime,
    formatDateShort,
    formatRelativeTime,
    formatDateTimeLocal,

    // Currency and numbers
    formatCurrency,
    formatNumber,

    // Date checks
    isToday,
    isPast,
    isFuture,
  }), []);

  return timezone;
}

export default useTimezone;
